import React from 'react';

import { ProductPod as DSProductPod } from '@johnlewispartnership/wtr-ingredients/ingredients/ProductPod';
import { usePodImpression } from 'hooks/use-pod-impression';
import { ListAnalytics } from 'analytics/types';
import { useDSPodProps } from './useDSPodProps';
import { makePodDataset, POD_TYPE_LIGHT } from './utils';

type ProductPodProperties = {
  imageLoading?: 'lazy' | 'eager' | undefined;
  lineNumber: string;
  position?: number;
  sponsored?: boolean;
  clickContext?: {
    type?: string;
    personalisation?: {
      type: string;
      name: string;
    };
    listDefinitions: ListAnalytics;
  };
  variant: 'light' | 'regular' | 'slim';
  listDefinitions: ListAnalytics;
  linkTarget?: HTMLAnchorElement['target'];
};

export const ProductPod = ({
  lineNumber,
  position = -1,
  sponsored = false,
  clickContext,
  imageLoading,
  variant = POD_TYPE_LIGHT,
  listDefinitions,
  linkTarget,
}: ProductPodProperties) => {
  const {
    product,
    conflict,
    trolleyQuantity,
    onFavouriteClick,
    onAddToTrolley,
    onUpdateTrolleyQuantity,
    productData,
    redOfferText,
  } = useDSPodProps({
    lineNumber,
    position,
    sponsored,
    clickContext,
    linkTarget,
  });

  const observeRef = usePodImpression(
    {
      position,
      productId: productData.id,
      searchType: '',
      listDefinitions,
    },
    false,
  );

  const dataset = makePodDataset({
    hasPromotions: !!productData.promotions?.length,
    lineNumber: productData.lineNumber,
    name: productData.name,
    productType: productData.productType,
    productPosition: position,
    conflictMessage: conflict?.messages?.shortItem?.toLowerCase(),
    podType: variant,
  }) as unknown as DOMStringMap;

  return (
    <DSProductPod
      // conform to type @johnlewispartnership/wtr-ingredients/ingredients/ProductPod#ProductPodProps
      ref={observeRef}
      variant={variant}
      dataset={dataset}
      product={product}
      conflict={conflict}
      trolleyQuantity={trolleyQuantity}
      onFavouriteClick={onFavouriteClick}
      onAddToTrolley={onAddToTrolley}
      onUpdateTrolleyQuantity={onUpdateTrolleyQuantity}
      redOfferText={redOfferText}
      imageLoading={imageLoading}
      trolleyControlsDisabled={false}
    />
  );
};
